import { render } from "./ClaimTypeSelector.vue?vue&type=template&id=5c64ecba&scoped=true&bindings={}"
import script from "./ClaimTypeSelector.vue?vue&type=script&lang=ts"
export * from "./ClaimTypeSelector.vue?vue&type=script&lang=ts"

import "./ClaimTypeSelector.vue?vue&type=style&index=0&id=5c64ecba&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5c64ecba"

export default script